module.exports = __webpack_public_path__ + "media/filter.132736ff.svg";